import type { useRouter } from "next/navigation";

type AppRouter = ReturnType<typeof useRouter>;
type PrefetchOptions = NonNullable<Parameters<AppRouter["prefetch"]>[1]>;

/**
 * Prefetch PENUH satu rute — RSC lengkap termasuk data halaman dinamis.
 *
 * `router.prefetch(href)` polos memakai jenis "auto": untuk halaman dinamis
 * (`/product/[slug]` ber-`force-dynamic`, tanpa `loading.tsx`) itu hanya
 * mengambil kerangka layout, bukan datanya — navigasi tetap menunggu server.
 * Jenis "full" mengambil halaman utuh sehingga navigasi berikutnya instan.
 *
 * Nilai `"full"` adalah `PrefetchKind.FULL` Next 16 (enum string di
 * `router-reducer-types`, diverifikasi pada next@16.3.3). Enum-nya hanya ada
 * di jalur internal Next, jadi cast-nya dikurung di SATU tempat ini.
 *
 * Dipanggil HANYA saat niat pembeli sudah jelas (menyeret ke pratinjau produk
 * lain / diam di foto ujung). Tautan storefront sengaja `prefetch={false}` —
 * prefetch per kartu yang terlihat menembakkan ratusan render per pengunjung
 * ke shared hosting; ini satu render untuk satu tujuan yang hampir pasti
 * dibuka. Prefetch hanya aktif di build produksi (Next mematikannya di dev).
 */
export function prefetchFull(router: Pick<AppRouter, "prefetch">, href: string): void {
  try {
    router.prefetch(href, { kind: "full" } as unknown as PrefetchOptions);
  } catch {
    // best-effort — gagal prefetch berarti navigasi biasa, bukan error.
  }
}
